export default {
  isMapReady: state => {
    return state.isReady;
  },
  getLoadedLayer: state => {
    return state.loaded_layers.asImmutable();
  },
  getVoyageHistorySummary: state => {
    return state.voyageHistorySummary;
  },
  getEnterpriseVoyageHistories: state => {
    return state.enterpriseVoyageHistories;
  },
  getProjectEnterpriseId: state => {
    return state.project.enterpriseId;
  },
  getHistories: state => {
    return state.histories;
  },
  getPlayHistoryId: state => {
    return state.playHistoryId;
  },
  getPreviousTime: state => {
    return state.history.previousTime;
  },
  getPlaySpeed: state => {
    return state.history.playSpeed;
  },
  getPause: state => {
    return state.is_pause;
  },
  getReverse: state => {
    return state.history.isReverse;
  },
  getTick: state => {
    return state.tick;
  },
  getFPS: state => {
    return state.fps;
  },
  getCurrentTime: state => {
    return state.current_time;
  },
  getGcTime: state => {
    return state.gc_time;
  },
  getStartTime: state => {
    return state.start_time;
  },
  getEndTime: state => {
    return state.end_time;
  },
  getMyVesselWake: state => {
    return state.my_vessel_wake.asImmutable().toArray();
  },
  getMapRect: state => {
    return state.map_info;
  },
  getMapCenter: state => {
    return state.map_info.center;
  },
  getMyVesselPositions: state => {
    return state.my_vessel_positions.asImmutable();
  },
  getMyVesselPositionAll: state => {
    return state.my_vessel_position_all.asImmutable();
  },
  getVesselPositions: state => {
    return state.vessel_positions.asImmutable().toList();
  },
  getMovementRecordList: state => {
    return state.movement_vessels.asImmutable();
  },
  getVoyageHistory: state => {
    return state.voyage_history;
  },
  getBackupIndex: state => {
    return state.backup_index;
  },
  getBackupIndexMyPos: state => {
    return state.backup_index.my_pos;
  },
  getBaseIndex: state => {
    return state.base_index;
  },
  getMaxIndex: state => {
    return state.max_index;
  },
  getPageable: state => {
    return state.pageable;
  },
  getChangeSliderStatus: state => {
    return state.change_slider;
  },
  getSearchVessels: state => {
    return state.search_vessels;
  },
  getSearchUsers: state => {
    return state.search_users;
  },
  getSearchVesselIds: state => {
    return state.search_vessels.map(d => d.id);
  },
  getSearchUserIds: state => {
    return state.search_users.map(d => d.id);
  }
};
